import { useCallback, useEffect, useRef, useState } from "react";

const usePlayerControls = (isPlayerOpen, hideDelay = 2800) => {
  const [controlsVisible, setControlsVisible] = useState(true);
  const hideTimerRef = useRef(null);

  const showControls = useCallback(() => {
    if (!isPlayerOpen) return;
    setControlsVisible(true);
    window.clearTimeout(hideTimerRef.current);
    hideTimerRef.current = window.setTimeout(
      () => setControlsVisible(false),
      hideDelay
    );
  }, [hideDelay, isPlayerOpen]);

  useEffect(() => {
    if (!isPlayerOpen) {
      window.clearTimeout(hideTimerRef.current);
      setControlsVisible(true);
      return undefined;
    }

    const handleActivity = () => showControls();
    const events = ["pointermove", "pointerdown", "keydown", "touchstart"];
    events.forEach((eventName) =>
      window.addEventListener(eventName, handleActivity, { passive: true })
    );
    showControls();

    return () => {
      window.clearTimeout(hideTimerRef.current);
      events.forEach((eventName) =>
        window.removeEventListener(eventName, handleActivity)
      );
    };
  }, [isPlayerOpen, showControls]);

  return { controlsVisible, showControls };
};

export default usePlayerControls;
